import styled from "styled-components";

export const Paragraph = styled.p`
  font-size: 0.9rem;
  font-weight: 300;
  line-height: 1.7;
  margin: 0;
  display: block;
`;

export const Lead = styled.p`
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.7;
  margin-top: 1.5rem;
`;
